import {RoleEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {RoleAction} from "./RoleActionMenu";
import {useRoleMutation} from "../../../hooks/useRoleMutation";

export type UseRoleActionProps = {}

export type UseRoleActionResult = {
  onRoleActionClick: (role: RoleEntity, action: RoleAction) => void;
}

export const useRoleAction = (props: UseRoleActionProps = {}): UseRoleActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteRole,
  } = useRoleMutation()

  const _onRoleActionClick = useCallback((role: RoleEntity, action: RoleAction) => {
    if (action === "EDIT") {
      navigate(`/roles/form`, {state: {id: role.id}})
    } else if (action === "DELETE") {
      deleteRole(role.id, undefined)
    }
  }, [navigate, deleteRole])

  return {
    onRoleActionClick: _onRoleActionClick
  }
}
